import { Component, OnInit } from "@angular/core";
import { StringService } from "./services/string.service";
import { CookieService } from "ngx-cookie-service";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent {
  title = "Fejlmelding";

  constructor(
    private stringService: StringService,
    private cookie: CookieService,
  ) {}

  ngOnInit() {
    this.stringService
      .getStrings(this.cookie.get("language"))
      .subscribe((strings: Object) => {
        this.stringService.toggle(strings);
      });
  }
}
